module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"レビュー整列基準"}}')
  delete Component.options._Ctor
}
